import AdminAuditFiltersComponent from './AdminAuditFilters/AdminAuditFilters'

export const AdminAuditFilters = AdminAuditFiltersComponent
